import * as globalConfig from './conf'

export default {
  globalConfig
}



// WEBPACK FOOTER //
// ./src/common/common.js